// extracted by mini-css-extract-plugin
export default {"container":"File_container__s2D5L","item":"File_item__B5Zhy","delete":"File_delete__3f+h5","name":"File_name__YEt8-","oriname":"File_oriname__LGuLN","none":"File_none__igx8b"};